import styled from 'styled-components'

export const CAPParentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  color: #fff;
  @media (orientation: landscape) {
    padding: 5% 10%;
  }
  @media (orientation: portrait) {
    padding: 10% 5%;
  }
  
  @media (max-width: 480px) {
    gap: 30px;
    padding: 15px;
  }
`

export const ProfileSectionGenericHeading = styled.div`
  color: #fff;
  font-size: 22px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: default;
  display: flex;
  align-items: center;
  
  @media (min-width: 1280px) {
    font-size: 28px;
  }
  
  @media (max-width: 480px) {
    font-size: 18px;
  }
`

export const CAPCreditsTableRow = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 2fr 1fr 1fr;
  gap: 12px;
  padding: 16px;
  /* Glass effect */
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: rgba(255, 255, 255, 0.25);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15), 0 6px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 12px;
    border-radius: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 10px;
    gap: 6px;
  }
  
  > div {
    padding: 8px;
    border: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    
    @media (max-width: 768px) {
      justify-content: space-between;
      text-align: left;
      padding: 10px 12px;
      font-size: 13px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      
      &:last-child {
        border-bottom: none;
      }
      
      &::before {
        content: attr(data-label);
        font-weight: 600;
        margin-right: 12px;
        color: rgba(255, 255, 255, 0.7);
        flex-shrink: 0;
        min-width: 80px;
      }
    }
    
    @media (max-width: 480px) {
      font-size: 12px;
      padding: 8px 10px;
      
      &::before {
        min-width: 70px;
        font-size: 11px;
      }
    }
    
    b {
      font-weight: 600;
      color: rgba(255, 255, 255, 0.95);
      
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
`

export const CAPPurchaseTableRow = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 2fr 1fr 1fr;
  gap: 12px;
  padding: 16px;
  /* Glass effect */
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: rgba(255, 255, 255, 0.25);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15), 0 6px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 12px;
    border-radius: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 10px;
    gap: 6px;
  }
  
  > div {
    padding: 8px;
    border: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    
    @media (max-width: 768px) {
      justify-content: space-between;
      text-align: left;
      padding: 10px 12px;
      font-size: 13px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      
      &:last-child {
        border-bottom: none;
      }
      
      &::before {
        content: attr(data-label);
        font-weight: 600;
        margin-right: 12px;
        color: rgba(255, 255, 255, 0.7);
        flex-shrink: 0;
        min-width: 80px;
      }
    }
    
    @media (max-width: 480px) {
      font-size: 12px;
      padding: 8px 10px;
      
      &::before {
        min-width: 70px;
        font-size: 11px;
      }
    }
    
    b {
      font-weight: 600;
      color: rgba(255, 255, 255, 0.95);
      
      @media (max-width: 768px) {
        display: none;
      }
    }
  }
`
